import { useSelector } from "react-redux";
import useScanDetection from 'use-scan-detection';

// import { useForm } from "../../hooks/useForm";
import { countDuplicatesItemArray } from "../../helpers/arrayFunctions";
import { Highlighter, Typeahead } from "react-bootstrap-typeahead";
import { useState } from "react";


export const ItemAdd = ({ onNewItem }) => {

    const { data, carritoItems } = useSelector( state => state.carrito );

    // const [ {codigo}, handleInputChange, reset ] = useForm({
    //     codigo: ''
    // });

    
    // UseScanDetection toma el codigo de barras sin que se encuentre el focus en el input
    useScanDetection({
        onComplete: (code) => { 
            // console.log(code);
        
            if( code.length <= 1) return;

            const result = data.find((i) => i.codigoBarras === code);

        if (result) {

           const quantity = countDuplicatesItemArray( code, carritoItems ); // Cuenta los items duplicados en el carrito

            const newItem = {
                id: new Date().getTime(),
                cant: quantity,
                codigo: result.codigoBarras,
                costo: result.precio,
                desc: result.articuloServicio
            }

            onNewItem(newItem);
            // reset();
        }

        }
    });

    // Toma el codigo de barras del input haciendo el submit
    // const onFormSubmit = ( event ) => {
    //     event.preventDefault();

    //     if( codigo.length <= 1) return;

    //     if (codigo.length) {
    //         for (let i = 0; i < codigo.length; ++i) {
    //             if (codigo[i] === '-') {
    //                 console.log('okay');
    //             }
    //         }
           
    //     }

    //     const result = data.find((i) => i.codigo === codigo);

    //     if (result) {

    //        const quantity = countDuplicatesItemArray( codigo, carritoItems ); // Cuenta los items duplicados en el carrito

    //         const newItem = {
    //             id: new Date().getTime(),
    //             cant: quantity,
    //             codigo: result.codigo,
    //             costo: result.costo,
    //             desc: result.desc
    //         }

    //         onNewItem(newItem);
    //         reset();
    //     }
    // }

    const [singleSelections, setSingleSelections] = useState([]);

    const handleCodeSelected = (event) => {
        console.log(event);
        setSingleSelections( [] );

        const [codigoArticulo] = event.map(data =>(data.codigoBarras) );

        if( codigoArticulo.length <= 1) return;

        if (codigoArticulo.length) {
            for (let i = 0; i < codigoArticulo.length; ++i) {
                if (codigoArticulo[i] === '-') {
                    codigoArticulo.log('okay');
                }
            }
           
        }

        const result = data.find((i) => i.codigoBarras === codigoArticulo);

        if (result) {

           const quantity = countDuplicatesItemArray( codigoArticulo, carritoItems ); // Cuenta los items duplicados en el carrito

            const newItem = {
                id: new Date().getTime(),
                cant: quantity,
                codigo: result.codigoBarras,
                costo: result.precio,
                desc: result.articuloServicio
            }

            onNewItem(newItem);
            // reset();
        }
    }

  return (
    <>
        {/* <form onSubmit={onFormSubmit}>
            <input 
            // autoFocus
            type="text"
            placeholder="Ingresa codigo barras"
            className="form-control"
            name="codigo"
            value={ codigo }
            onChange={ handleInputChange }
            /> */}

            {/* <button type="submit" className="btn btn-primary mt-1">
            Agregar
            </button> */}
        {/* </form> */}
        <div className="row g-2 mb-2">
            <div className="form-group col-md-2">
                <input type="text" aria-label="First name" id="cantidadItem" className="form-control w-5" placeholder="Cant" />
            </div>

            <div className="form-group col-md-10">

                <Typeahead
                id="basic-typeahead-single"
                clearButton
                labelKey={(data) => `${data.articuloServicio} ${data.codigoBarras}`}
                minLength={1}
                onChange={handleCodeSelected}
                options={data}
                placeholder="Buscar artículo..."
                renderMenuItemChildren={(option, props, idx) => (
                                            <div>
                                                <Highlighter search={props.text}>
                                                    {option.articuloServicio}
                                                </Highlighter> 
                                                <div>
                                                    <small>
                                                        Precio unit: {option.precio}
                                                    </small>
                                                </div>
                                                <div>
                                                    <small>
                                                        Código: {option.codigoBarras}
                                                    </small>
                                                </div>
                                            </div>
                                            )}
                selected={singleSelections}
                />
            </div>
        </div>

        
    </>
  )
}
